import { CategoryApiOutput } from 'types/category'
import {
    TenantIntegration,
    TenantIntegrationApiOutput,
} from 'types/tenant-integration'
import { useApiRequest } from 'utils/fetch-helper'
import { getIntegrationCategories } from './category'

export function useTenantIntegrationService() {
    const { getApiRequest } = useApiRequest()

    const getLocationPaymentIntegrations = async function (
        location_id: string
    ): Promise<TenantIntegration[]> {
        const [payment_category] = (await getIntegrationCategories()).filter(
            (category: CategoryApiOutput) =>
                category.name.toLocaleLowerCase().indexOf('payment') == 0
        )
        let records: TenantIntegration[] = []
        if (payment_category) {
            const { content, message } = await getApiRequest(
                `/v1/tenant-integrations/by-location-id?locationId=${location_id}`
            )
    
            records = content.map((p: TenantIntegrationApiOutput) => ({
                id: p.id,
                client_secret: p.clientSecret,
                connected_account_id: p.connectedAccountId,
                integration: {
                    id: p.integrationId,
                },
                location: {
                    id: p.locationId,
                },
            }))
        }
        return records
    }

    return {
        getLocationPaymentIntegrations
    }
}

